var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"admin-page"},[_c('b-breadcrumb',{attrs:{"items":_vm.items}}),_c('Datatable',{attrs:{"title":_vm.title,"title-slug":_vm.title_slug,"ths":_vm.ths,"tds":_vm.tds},on:{"refresh":_vm.handleEdit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }